<template>
    <div class="upload-file">
      <el-upload ref="upload" class="upload-demo" drag action="" :auto-upload=false :accept="accept" :headers="headers"
                 :http-request="handleUploadFile" :before-upload="handleBefore" :on-change="handleChange"
                 :show-file-list="false"
                 multiple :limit=1 :file-list="file_list">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip" style="color: red;">{{ '说明: ' + accept }}</div>
      </el-upload>
  
      <!-- 业务table -->
      <el-table :key="tableKey" :data="file_list" stripe fit highlight-current-row class="w-100 mt-1" size="mini">
        <!-- 名称 -->
        <el-table-column align="left" label="文件名称" width="220">
          <template slot-scope="scope">
            <span class="text-link">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left" min-width="100" prop="rename">
          <template slot="header">
            <span style="color: red;">*</span><span>重命名</span>
          </template>
          <template slot-scope="scope">
            <file-rename :ref="'rename' + scope.row.uid" :object-type="objectType" :file-type-list="fileTypeList"
                         :cert-file="scope.row" :visible="true"
                         v-bind="$attrs"
                         v-on="$listeners"></file-rename>
          </template>
        </el-table-column>
  
        <!-- 大小 -->
        <el-table-column align="left" label="文件大小" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.size }}</span>
          </template>
        </el-table-column>
  
        <!-- 按钮组 -->
        <el-table-column align="left" label="操作" class-name="small-padding" width="60">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="handleDelete(scope.row)" icon="el-icon-delete"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </template>
  
  <script>
    /* eslint-disable */
    import {
      fetchFileTypeList,
      fetchSubFileTypeList,
      saveInsuranceObjectFileList
    } from "@/api/common"
    import {
      getToken
    } from "@/utils/auth"
    import {
      uploadFile
    } from "@/api/upload"
    import {
      error_message
    } from "@/utils/misc"
    import {
      parseTime
    } from '@/utils'
  
    import FileRename from "@/components/FileRename"
    import { uploadSupplementRelationFile } from "@/api/supplement"
  
    export default {
      name: "upload-file",
      components: {
        FileRename
      },
      props: {
        objectType: {
          type: String,
          default: 'ship.ship'
        },
        objectId: {
          type: [Number, String]
        },
        fileTypeList: Array,
        accept: {
          type: String,
          default: ".doc,.docx,.xls,.xlsx,.pdf,.jpeg,.jpg,.gif,.png",
          required: false
        },
        isUpload: {
          type: Boolean,
          default: true
        },
      },
      data() {
        return {
          tableKey: 0,
          current_file_type: {},
          file_list: [],
          dialogVisible: false,
          limit: 30
        }
      },
      computed: {
        headers() {
          return {
            Authorization: "Token " + getToken()
          }
        }
      },
      methods: {
        handleUpload() {
          let upload = true, file_type_obj, error_message
  
          // check file_type before upload
          this.file_list.forEach(item => {
  
            const isLt10M = item.size / 1024 / 1024 < 10
  
            if (!isLt10M) {
              this.$set(item, 'error_message', '文件大小不能超过10MB')
              upload = false
              return
            }
  
            if (item.file_type_code === undefined) {
              this.$set(item, 'error_message', '请选择附件类型')
              upload = false
              return
            }
  
            file_type_obj = this.fileTypeList.find(type => {
              return (type.code === item.file_type_code)
            })
  
            if (file_type_obj.date_type === "F") {		// 发证日
              if (item.file_date) {	// 发证日不能大于当前日期
                let today = parseTime(new Date(), "{y}-{m}-{d}")
                if (item.file_date > today) {
                  this.$set(item, 'error_message', '发证日不能大于当前日期')
                  upload = false
                  return
                }
              } else {
                this.$set(item, 'error_message', "请选择证件的发证日")
                upload = false
                return
              }
            }
  
            if (file_type_obj.date_type === "D") {
              if (item.file_date) {	// 到期日不能大于当前日期
                let today = parseTime(new Date(), "{y}-{m}-{d}")
                if (item.file_date < today) {
                  this.$set(item, "error_message", "证件到期日不能小于当前日期")
                  upload = false
                  return
                }
              } else {
                this.$set(item, 'error_message', '请选择证件的到期日')
                upload = false
                return
              }
            }
  
            this.$set(item, 'error_message', undefined)
          })
  
          if (upload) this.$refs.upload.submit()
        },
        handleChange(file, fileList) {
          if (fileList.length > 1) {
            this.$refs.upload.fileList.some(item => {
              if (item.status !== 'success' && item.name == file.name && item.size == file.size) {
                this.$message.error("文件[" + file.name + "]已经选择，请勿重复上传")
                fileList.pop()
                return true
              }
            })
          }
  
          this.file_list = fileList
        },
        handleDelete(file) {
          let index = this.$refs.upload.fileList.indexOf(file)
          if (index != -1) {
            this.$refs.upload.fileList.splice(index, 1)
          }
        },
        handleExceed() {
          this.$message.error("最多只能上传" + this.limit + "个文件")
        },
        handleBefore(file) {
  
          let upload = true, file_type_obj, error_message
  
          // check file_type before upload
          this.file_list.forEach(item => {
  
            const isLt10M = item.size / 1024 / 1024 < 10
  
            if (!isLt10M) {
              this.$set(item, 'error_message', '文件大小不能超过10MB')
              upload = false
              return
            }
  
            if (item.file_type_code === undefined) {
              this.$set(item, 'error_message', '请选择附件类型')
              upload = false
              return
            }
  
            file_type_obj = this.fileTypeList.find(type => {
              return (type.code === item.file_type_code)
            })
  
            if (file_type_obj.date_type && !item.file_date) {
              error_message = file_type_obj.date_type === 'F' ? "发证日" : "到期日"
              this.$set(item, 'error_message', "请选择证件的" + error_message)
              upload = false
              return
            }
  
            this.$set(item, 'error_message', undefined)
          })
  
          return upload
        },
        handleSuccess(response, file, fileList) {
          this.$message.success(response)
        },
        handleError(error, file, fileList) {
          error_message(error)
        },
        handleUploadFile(param) {
          let new_name, file_type_code, file_date, file_obj, finished = false, file = param.file
  
          file_obj = this.file_list.find(item => {
            return (item.name === file.name && item.size === file.size)
          })
  
          if (this.isUpload) {
            let fd = new FormData()
  
            fd.append("file", file)
            // fd.append("object_id", this.objectId)
  
            if (file_obj === undefined) {
              this.$message("要上传的文件不存在")
              return
            }
  
            file_type_code = file_obj.file_type_code
            file_date = file_obj.file_date
            new_name = file_obj.new_name
  
            // fd.append("object_type", this.objectType)
            fd.append("file_type_code", file_type_code)
            fd.append("file_date", file_date)
            fd.append("new_name", new_name)
            // console.log(fd)
            uploadSupplementRelationFile(this.objectId, fd)
              .then(res => {
                param.onSuccess(res)
                this.$set(file_obj, 'uploaded', true)
                this.$emit("uploaded")
  
                finished = !this.file_list.some(item => {
                  return (!item.uploaded)
                })
  
                if (finished) {
                  this.file_list = []
                  this.$refs.upload.clearFiles()
                }
              })
              .catch(error => {
                param.onError(error)
                error_message(error)
              })
          } else {
            this.$set(file_obj, 'uploaded', true)
            finished = !this.file_list.some(item => {
              return (!item.uploaded)
            })
  
            if (finished) {
              this.$emit("appended", this.file_list)
              this.file_list = []
              this.$refs.upload.clearFiles()
            }
          }
        }
      }
    }
  
  </script>
  
  <style>
    .upload-file .el-upload {
      display: block !important;
    }
  
    .upload-file .el-upload-dragger {
      width: 100%;
      height: 114px;
    }
  
    .upload-file .el-upload-dragger .el-icon-upload {
      margin: 28px 0 20px;
      line-height: 28px;
    }
  
    .upload-file .input-mini {
      height: 26px;
      line-height: 26px;
    }
  
    .upload-file .input-mini > input {
      height: 24px !important;
      line-height: 24px !important;
    }
  
    .upload-file .el-input-group__append,
    .upload-file .el-input-group__prepend {
      padding: 0 10px;
    }
  
    .upload-file .input-with-select {
      width: 90%;
    }
  
    .upload-file .el-input--suffix .el-input__inner {
      padding-right: 10px !important;
    }
  
  </style>
  